import { createContext } from 'react';
import { useState } from 'react';

export const RegionContext = createContext({
  regionData: {},
  setRegionData: () => {}
});

export default function RegionContextProvider({ children }) {
  const [regionData, setRegionData] = useState({
    // Variables  here
    loaded: false
  });

  return (
    <RegionContext.Provider className="region" value={[regionData, setRegionData]}>
      {children}
    </RegionContext.Provider>
  );
}
